import { apiService } from "@/_services";
import { formatDate_YMD } from "@/_core/_helpers/_helpers";

/**
 * Retrieves forward and volatility data for commodities
 * @param {object} ctx: context variables, must include ctx.currencyNumber and ctx.initCurrencyDate
 */
export function getFWDVolCommodities(ctx) {
  const params = {
    method: "GET",
    endpoint: "commodity_ohlc_fwd_vol_rr",
    content_type: "application/json",
    query_params: {
      format: "json",
      commodity: ctx.currencyNumber,
      observation_date: formatDate_YMD(
        new Date(new Date().setFullYear(new Date().getFullYear() - 5))
      )
    }
  };
  return apiService.getAll(params);
}
